import { mediumFont, regularFont, theme } from "../../../utils/styles";

const compatibilityComponentsStyles = {
  usersContainer: {
    display: "grid",
    gridTemplateColumns: {
      md: "repeat(2, 1fr)",
      sm: "repeat(1, 1fr)",
      xs: "repeat(1, 1fr)",
    },
    gap: "24px",
  },
  userCard: {
    background: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    borderRadius: "20px",
    padding: "24px",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s ease-in-out",
  },
  userHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "24px",
    gap: "16px",
    padding: "16px",
    background: "rgba(255, 255, 255, 0.08)",
    borderRadius: "12px",
    border: "1px solid rgba(138, 88, 203, 0.2)",
  },
  avatar: {
    width: "70px",
    height: "70px",
    borderRadius: "35px",
    background:
      "linear-gradient(135deg, rgba(138, 88, 203, 0.2), rgba(138, 88, 203, 0.1))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid rgba(138, 88, 203, 0.3)",
    [theme.breakpoints.down("sm")]: {
      width: "40px",
      height: "40px",
    },
  },
  userName: {
    ...mediumFont,
    fontSize: "1.75rem",
    color: "#FFFFFF",
    marginBottom: "4px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "300px",
    [theme.breakpoints.down("xl")]: {
      maxWidth: "400px",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "300px",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "150px",
      fontSize: "1rem",
    },
  },
  nickname: {
    ...regularFont,
    fontSize: "1rem",
    color: "rgba(255, 255, 255, 0.7)",
  },
  detailsContainer: {
    display: "grid",
    gridTemplateColumns: {
      sm: "repeat(2, 1fr)",
      xs: "repeat(1, 1fr)",
    },
    gap: "16px",
    marginTop: "20px",
  },
  detailRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    padding: "12px",
    background: "rgba(255, 255, 255, 0.08)",
    borderRadius: "12px",
    transition: "background 0.2s",
  },
  icon: {
    color: "rgba(138, 88, 203, 0.8)",
    width: "24px",
    height: "24px",
  },
  label: {
    ...regularFont,
    color: "rgba(255, 255, 255, 0.5)",
    fontSize: "0.875rem",
    marginBottom: "4px",
  },
  value: {
    ...regularFont,
    color: "#FFFFFF",
    fontSize: "1rem",
    wordBreak: "break-word",
  },

  // Add new styles for percentage cards
  percentageContainer: {
    mt: 4,
  },
  percentageCard: {
    background: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    borderRadius: "20px",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    transition: "transform 0.2s ease-in-out",
  },
  percentageCardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    flexGrow: 1,
  },
  percentageHeader: {
    ...mediumFont,
    color: "#FFFFFF",
    fontSize: "1.25rem",
    textAlign: "center",
  },
  infoNote: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    marginTop: "20px",
    padding: "10px 14px",
    borderRadius: "10px",
    background: "rgba(138, 88, 203, 0.12)",
    border: "1px solid rgba(138, 88, 203, 0.3)",
  },
  infoNoteIcon: {
    fontSize: "1rem",
    color: "rgba(138, 88, 203, 0.9)",
    flexShrink: 0,
    marginTop: "1px",
  },
  infoNoteText: {
    ...regularFont,
    color: "rgba(255, 255, 255, 0.6)",
    fontSize: "0.75rem",
    lineHeight: "1.5",
  },
  totalPercentageCard: {
    border: "2px solid #8a58cb",
    boxShadow: "0 6px 32px rgba(138, 88, 203, 0.25)",
    color: "#FFF",
    position: "relative",
    zIndex: 2,
    padding: "32px",
    transition: "transform 0.2s ease-in-out",
    mx: 10,
    width: "auto",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      mx: 0,
    },
  },
  percentageValue: {
    ...mediumFont,
    fontSize: "2.5rem",
    color: "#8a58cb",
    display: "flex",
    alignItems: "baseline",
    gap: "4px",
  },
  percentageSymbol: {
    fontSize: "1.5rem",
    opacity: 0.7,
  },
  resultText: {
    ...regularFont,
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "1rem",
    textAlign: "center",
  },
  progressBarContainer: {
    width: "100%",
    height: "8px",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: "4px",
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    backgroundColor: "#8a58cb",
    borderRadius: "4px",
    transition: "width 1s ease-in-out",
  },
  totalCompatibility: {
    gridColumn: {
      lg: "span 3",
      md: "span 2",
      sm: "span 1",
      xs: "span 1",
    },
  },
} as const;

export default compatibilityComponentsStyles;
